import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { useStaticData } from "../../utils/data";

const Socials = () => {
  const { SOCIALS } = useStaticData();
  const onClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className="d-flex gap-3 mt-3">
      {SOCIALS.map((item) => (
        <FontAwesomeIcon
          className="tab-element"
          key={item.title}
          icon={`fa-brands ${item.icon}`}
          size="lg"
          onClick={() => onClick(item.link)}
        />
      ))}
    </div>
  );
};

export default memo(Socials);
